/** Normalizes a DRF list response into a consistent shape, whether
 * pagination is on (the normal case — {count, next, previous, results})
 * or a view has pagination_class = None (falls back to a bare array).
 */
export function parsePaginatedResponse<T = any>(data: any): {
  results: T[]
  count: number
  hasNext: boolean
  hasPrev: boolean
} {
  if (Array.isArray(data)) {
    return { results: data, count: data.length, hasNext: false, hasPrev: false }
  }
  return {
    results: data?.results || [],
    count: data?.count ?? 0,
    hasNext: !!data?.next,
    hasPrev: !!data?.previous,
  }
}
